// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import reportReducer from '../features/reports/reportSlice';
import transactionReducer from '../features/transactions/transactionSlice';
import queryResponseReducer from '../features/queryResponses/queryResponseSlice';
import queryReducer from '../features/queries/querySlice';
import employeeReducer from '../features/employees/employeeSlice';
import storeReducer from '../features/stores/storeSlice';
import employeeTargetReducer from '../features/employeeTargets/employeeTargetSlice';
import { setupInterceptors } from '../api/axiosInstance';
import storeOwnerReducer from '../features/storeOwners/storeOwnerSlice';
import loadingReducer from '../features/loading/loadingSlice';
import loadingMiddleware from '../middleware/loadingMiddleware';
import notificationReducer from '../features/notifications/notificationSlice';
import announcementReducer from '../features/announcements/announcementSlice';

// NEW: Import Attendance and Leave reducers
import attendanceReducer from '../features/attendance/attendanceSlice';
import leaveReducer from '../features/leave/leaveSlice';
import cashierReducer from '../features/cashierAssistance/cashierSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    reports: reportReducer,
    transactions: transactionReducer,
    queryResponses: queryResponseReducer,
    queries: queryReducer,
    employees: employeeReducer,
    stores: storeReducer,
    employeeTargets: employeeTargetReducer,
    storeOwners: storeOwnerReducer,
    loading: loadingReducer,
    notifications: notificationReducer,
    announcements: announcementReducer,
    
    // NEW: Add Attendance and Leave Management reducers
    attendance: attendanceReducer,
    leave: leaveReducer,
    cashierTickets: cashierReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization check
        ignoredActions: [
          'attendance/fetchLiveAttendance/fulfilled',
          'leave/applyLeave/fulfilled',
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          'meta.arg', 
          'payload.timestamp', 
          'payload.documents',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'attendance.liveAttendance',
          'leave.employeeLeaves.documents',
        ],
      },
    }).concat(loadingMiddleware),
});

// Set up interceptors after the store is created
setupInterceptors(store);

export default store;